import {translate} from '../locale';
/** Playback and navigation share the complete site catalogue. */
export function cinemaCopy(locale:string){
 const copy=locale.startsWith('ru')?{
  start:'Смотреть, как это работает',hint:'Автоматический показ с паузами между главами',
  next:'Смотреть дальше',download:'Скачай Blender Bridge',gesture:'Нажми или слегка прокрути вниз',
  pause:'Пауза',resume:'Продолжить',replay:'Повторить главу',navigation:'Разделы сайта',
  links:['Как работает','Возможности','Тарифы','Скачать'],
 }:{
  start:'See how it works',hint:'An automatic tour, with pauses between chapters',
  next:'Continue the tour',download:'Download Blender Bridge',gesture:'Tap or scroll slightly to continue',
  pause:'Pause',resume:'Resume',replay:'Replay chapter',navigation:'Site sections',
  links:['How it works','Features','Pricing','Download'],
 };
 return {...copy,...Object.fromEntries(Object.entries(copy).filter(([,value])=>typeof value==='string').map(([key,value])=>[key,translate(value as string,undefined,locale)])),links:copy.links.map(value=>translate(value,undefined,locale))};
}
